export default "__VITE_ASSET__51b91a55__"